export class ReelsEvents {
    public static readonly SPIN_ENDED: symbol = Symbol('SPIN_ENDED');
    public static readonly REELS_SPINNING_STARTED: symbol = Symbol('REELS_SPINNING_STARTED');
    public static readonly REELS_RESPINNING_STARTED: symbol = Symbol('REELS_RESPINNING_STARTED');
    public static readonly REEL_STOPPED: symbol = Symbol('REEL_STOPPED');
    public static readonly ALL_REELS_STOPPED: symbol = Symbol('ALL_REELS_STOPPED');
    public static readonly REEL_START_STOPPING: symbol = Symbol('REEL_START_STOPPING');
    public static readonly REELS_QUICKSTOP_STATE_ENTERED: symbol = Symbol('REELS_QUICKSTOP_STATE_ENTERED');
    public static readonly REELS_RESTORED_AFTER_FREESPIN: symbol = Symbol('REELS_RESTORED_AFTER_FREESPIN');
    public static readonly ENABLE_SPIN_BY_SPIN_BUTTON: symbol = Symbol('ENABLE_SPIN_BY_SPIN_BUTTON');
    public static readonly DISABLE_SPIN_BY_SPIN_BUTTON: symbol = Symbol('DISABLE_SPIN_BY_SPIN_BUTTON');
}